import { render, staticRenderFns } from "./BudgetInfo.vue?vue&type=template&id=c186a5e6"
import script from "./BudgetInfo.vue?vue&type=script&lang=js"
export * from "./BudgetInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c186a5e6')) {
      api.createRecord('c186a5e6', component.options)
    } else {
      api.reload('c186a5e6', component.options)
    }
    module.hot.accept("./BudgetInfo.vue?vue&type=template&id=c186a5e6", function () {
      api.rerender('c186a5e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/jornalPayment/components/details/BudgetInfo.vue"
export default component.exports